import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router, ActivatedRoute} from '@angular/router';
import {AuthService} from '../../services';
import {setAuthToken} from '../../helpers/storage-helper';
import {RoleService} from '../../services/role.service';
import {CredentialsModel} from '../../models/credentials-model';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  user: CredentialsModel = new CredentialsModel('', '', false);
  loading: boolean;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private roleService: RoleService,
  ) {
  }

  ngOnInit() {
    this.initForm(this.user);
  }

  initForm(user: CredentialsModel) {
    this.loginForm = this.formBuilder.group({
      username: [user.username, Validators.required],
      password: [user.password, Validators.required],
      remind: [user.remind],
    });
  }

  onSubmit(form: FormGroup) {
    this.loading = true;

    this.authService.login(form.value).subscribe(data => {
      let remind = form.value.remind;

      if (data.needTwoFactor) {
        remind = false;
      }

      setAuthToken(data.authToken, remind);
      this.roleService.setRoles(data.roles, remind);

      let returnUrl = this.route.snapshot.queryParams['returnUrl'] || '';
      if (returnUrl == '/login') {
returnUrl = '';
}

      if (data.needTwoFactor) {
        this.router.navigate(['enter-2fa'], {queryParams: {returnUrl}});
        return;
      }

      if (this.roleService.hasRoles('must_enable_multifactor')) {
this.router.navigate(['my-account', 'must-activate-mfa']);
} else {
this.router.navigate(['start'], {queryParams: {returnUrl}});
}
    }, err => {
      this.loading = false;
      console.log(err);
    });
  }

}
